export const leaderBoardColums = [
    {
        label: 'Rank',
        field: 'studentId',
        width: 270
    },
    {
        label:"Student Name",
        sort: 'asc',
        field: "name",
        width: 270
    },
    {
        label :" Score",
        field: "mark",
        sort: 'asc',
        width: 270
    },

]
